<template>
    <IonPage>
        <IonContent>
            <IonGrid class="p-6">
                <IonRow class="row ion-justify-content-end">
                    <IonCol
                        size="1"
                        class="flex justify-end"
                    >
                        <IonToggle
                            :checked="activityStore.isActivityRunning"
                            @ion-change="toggleActivity"
                        />
                    </IonCol>
                </IonRow>
                <FormItem :label="$t('form.name')">
                    <IonInput
                        type="text"
                        :disabled="true"
                        :value="userStore?.user?.username"
                    />
                </FormItem>
                <FormItem :label="$t('form.userId')">
                    <IonInput
                        type="text"
                        class="id-input-field"
                        :disabled="true"
                        :value="userStore?.user?.documentId"
                    />
                </FormItem>
                <FormItem :label="$t('form.groupsize')">
                    <IonInput
                        type="number"
                        class="group-size-input"
                        :placeholder="activityStore.groupSize.toString()"
                        @ion-change="activityStore.setGroupSize(Number($event.detail.value))"
                    />
                </FormItem>
                <FormItem :label="$t('form.dog')">
                    <IonSelect
                        class="ml-4 ion-select"
                        interface="popover"
                        :placeholder="$t('form.yes')"
                        @ion-change="activityStore.setDog($event.detail.value)"
                        :value="activityStore.dog"
                    >
                        <IonSelectOption
                            v-for="option in dogOptions"
                            :key="option.id"
                            :value="option.value"
                        >{{ option.label }}
                        </IonSelectOption>
                    </IonSelect>
                </FormItem>
                <FormItem :label="$t('form.transport')">
                    <IonSelect
                        class="ml-4 ion-select"
                        interface="popover"
                        :placeholder="$t('form.bike')"
                        @ion-change="activityStore.setTransportation($event.detail.value)"
                        :value="activityStore.transportation"
                    >
                        <IonSelectOption
                            v-for="option in transportationOptions"
                            :key="option.value"
                            :value="option.value"
                        >{{ option.label }}
                        </IonSelectOption>
                    </IonSelect>
                </FormItem>
                <IonRow class="justify-self-start mt-6">
                    <IonCol>
                        <p class="text-xs"><strong>{{ $t("form.noteTitle") }}: </strong>{{ $t("form.noteBody") }}</p>
                    </IonCol>
                </IonRow>
            </IonGrid>
            <div class="w-full absolute bottom-0 flex justify-center text-xs">
                <ActivityBanner
                    v-if="activityStore.isActivityRunning"
                    class="w-full mx-2 mb-4 max-w-64"
                    :text="$t('activity.started')"
                    :button-text="$t('activity.map')"
                    :icon="caretForwardCircleOutline"
                    iconColor="green"
                    @click="goToMap"
                />
            </div>
        </IonContent>
    </IonPage>
</template>

<script
    lang="ts"
    setup
>
import ActivityBanner from '@/components/elements/ActivityBanner.vue';
import useHeader from '@/composables/useHeader';
import { RouteNames } from '@/router/routes';
import { useActivityStore } from '@/store/activity.ts';
import { useUserStore } from '@/store/user';
import { TransportationTypes } from '@/types/base-model';
import { IonCol, IonContent, IonGrid, IonInput, IonPage, IonRow, IonSelect, IonSelectOption, IonToggle } from '@ionic/vue';
import { caretForwardCircleOutline } from "ionicons/icons";
import { FormItem } from '@movinglayers/controls';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const activityStore = useActivityStore();
const userStore = useUserStore();
const router = useRouter();

const { t } = useI18n();

useHeader({
    title: t("header.activity"),
    showBackButton: true,
    goBackRoute: "/"
});

const dogOptions = [{
    id: "yes",
    value: true,
    label: t('form.yes')
}, {
    id: "no",
    value: false,
    label: t('form.no')
}];

const transportationOptions: { value: TransportationTypes, label: string; }[] = [{
    value: 'bike',
    label: t('form.bike')
}, {
    value: 'foot',
    label: t('form.foot')
}, {
    value: 'mountainbike',
    label: t('form.mountainbike')
}, {
    value: 'horse',
    label: t('form.horse')
}, {
    value: 'winter-activity',
    label: t('form.winter')
}];

const toggleActivity = async (e: CustomEvent) => {
    activityStore.isActivityRunning = e.detail.checked;
};

const goToMap = () => {
    router.push({ name: RouteNames.MAP });
};

</script>


<style scoped>
:deep(ion-input input) {
    margin-top: 1rem;
    text-align: right !important;
}

:deep(ion-input.id-input-field input) {
    font-size: 0.8rem;
}

ion-select::part(label) {
    display: flex;
    /* shows the label part that is hidden (because empty) and aligns the value part thereby to the right */
}

ion-select::part(container),
ion-select::part(icon) {
    margin-top: 15px;
    /* no better way to align vertically at the bottom available through the ionic parts */
}

ion-toggle {
    --track-background: #D9D9D9;
    --track-background-checked: var(--action-button-color);
    --handle-background: white;
    --handle-background-checked: white;
    --handle-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.14),
        0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
</style>

<style></style>